import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { Section } from "../../Common/layout/Section";
import { CardManagement } from "./Cards";

export default function CardManagementPages() {
  return (
    <>
      <AsideMenu>
        <UserGroupMenu destination="/cards" />
      </AsideMenu>
      <Section>
        <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>
            <ContentRoute path="/cards/:userGroup" component={CardManagement} />
          </Switch>
        </Suspense>
      </Section>
    </>
  );
}
